import React from 'react';
import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { useNavigate } from 'react-router-dom';

const RegisteredSuccessfuly = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className='d-flex gap-2 justify-content-start align-items-center mt-2 mx-3 cursor_pointer' onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='logo' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '90vh' }}>
                <Row>
                    <Col>
                        <Card className="text-center" style={{ width: '50rem' }}>
                            <Card.Body>
                                <Card.Title>Registered Successfully</Card.Title>
                                <Card.Text className='d-flex justify-content-center my-3 text-black'>
                                    Congratulations on successfully registering for our application! We are excited to have you on board. To begin exploring all the features and services, please proceed to log in using your credentials. Should you encounter any issues or require further assistance, do not hesitate to reach out to our support team. We look forward to supporting your journey with our platform and ensuring you have a seamless experience as you leverage our solutions to meet your business needs.
                                </Card.Text>
                                <Card.Footer>
                                    <Button onClick={() => navigate('/')} >Login</Button>
                                </Card.Footer>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default RegisteredSuccessfuly;
